<template>
    <h1 class="card-title "><b>{{ titleHead }}</b></h1>
    <div class="card-tools" :class="toolContentCss">
        <div class="input-group input-group-sm">
            <input v-if="btnSearch" v-model="searchParameters" type="text" class="form-control float-right" :class="customCssBtn.customInput" placeholder="Search">
            <div class="input-group-append">
                <button v-if="btnSearch" type="button" class="btn" :class="customCssBtn.custombtn" v-on:click="handleSearch">
                    <i class="fas fa-search"></i>
                </button>
                <button v-if="btnCreate" type="button" class="btn" :class="customCssBtn.custombtn" v-on:click="handleCreate">
                    <i class="fa fa-plus-square"></i>
                </button>
                <button v-if="btnToggle" type="button" class="btn" :class="customCssBtn.custombtn" data-card-widget="collapse">
                    <i class="fas fa-minus"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
    defineProps<{
        titleHead: string,
        toolContentCss: string,
        customCssBtn: { customInput: string, custombtn: string },
        btnCreate: boolean,
        btnSearch: boolean,
        btnToggle: boolean
    }>();

    const emit = defineEmits<{
        (e: 'operationSearch', params: string): void,
        (e: 'operationCreate'): void
    }>();

    const searchParameters = ref<string>('');
    const handleSearch = () => emit('operationSearch', searchParameters.value); 
    const handleCreate = () => emit('operationCreate');
</script>